import { Injectable, OnDestroy } from '@angular/core';
import { Modal} from 'ngx-modialog/plugins/bootstrap';

@Injectable()
export class MensagemUtilService {

    constructor(public modal: Modal){}
    
    sucesso(){
        this.modal.alert()
            .size('sm')
            .isBlocking(true)
            .showClose(false)
            .keyboard(27)
            .title('Sucesso!')
            .body('Os dados foram salvos com sucesso.')
            .open();
    }

    erro(erro: any) {
        this.modal.alert()
            .size('lg')
            .isBlocking(true)
            .showClose(false)
            .keyboard(27)
            .title('Erro!')
            .body(erro)
            .open();
    }

    alerta(mensagem: any){
        this.modal.alert()
            .size('lg')
            .isBlocking(true)
            .showClose(false)
            .keyboard(27)
            .title('Alerta!')
            .body(mensagem)
            .open();
    }

    isClosed(): boolean {
        return false;
    }

    confirmacao(titulo, mensagem: any, callbackOK: Function, callbackCancel: Function) {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(false)
            .keyboard(27)
            .title(titulo)
            .body(mensagem)
            .okBtn('Sim')
            .cancelBtn('Não')
            .open()
            .then((dialog) => dialog.result)
            .then(
                (onfulfilled) => callbackOK(),
                (onrejected) => callbackCancel()
            );
    }

}


// WEBPACK FOOTER //
// ./src/app/util/mensagemutil.service.ts